import { isDefined } from '../variables';

/**
 * Returns a value indicating whether the element has been overflowed.
 * Both in horizontal and vertical direction.
 * @param element HTML element.
 */
export const isElementOverflowed = (element: Element) => {
  // 1px subtracted from scroll height, as scrollHeight for some reason is 1px greater than
  // clientHeight. This means, without -1px, this function is returning true even for elements that
  // are not overflowing (check asset name). (check asset name). Works without -1px for cad group
  // name for instance.
  //
  // So this is a temporary solution to fix this problem. By subtracting 1 px from scroll height.
  return (
    element.scrollWidth > element.clientWidth || element.scrollHeight - 1 > element.clientHeight
  );
};

/**
 * Creates a canvas element width the specified dimensions and asserts that context 2d exists.
 */
export function createCanvasWithContext2d(width: number, height: number) {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d');

  if (!isDefined(context)) {
    throw Error('Unable to create canvas element. Context 2D is undefined.');
  }

  return { canvas, context };
}
